import GameViewSimpleController from "../GameViewSimple/GameViewSimpleController";

/**
 * FreeSpinsGameViewController — the Cleopatra's Fire free spins room.
 *
 * free_spins_game_view is the SAME skeleton as game_view (same bones, slots,
 * skins and clips; only the art differs), so everything — layout skins, idle,
 * scaling, the two reel slots — is GameViewSimpleController's. This class only
 * points it at the other spine and at its own registry keys.
 *
 * Its own keys, not "gameView.*": both rooms are mounted at once, so a shared
 * key would have the second controller overwrite the first.
 *
 * The reel slots and the window clip are hand edits in
 * free_spins_game_view.json, the same as in game_view.json — a re-export
 * drops them.
 */
export const FREE_SPINS_GAME_VIEW_SLOTS = {
  REEL_SET: "freeSpinsGameView.reelSet",
  OVERLAY_REEL_SET: "freeSpinsGameView.overlayReelSet",
};

class FreeSpinsGameViewController extends GameViewSimpleController {
  static SCENE = {
    TAG: "FreeSpinsGameView",
    SKELETON: "free_spins_game_view-skeleton",
    ATLAS: "free_spins_game_view-atlas",
    SPINE_NAME: "free_spins_game_view",
    REEL_SET_KEY: FREE_SPINS_GAME_VIEW_SLOTS.REEL_SET,
    OVERLAY_REEL_SET_KEY: FREE_SPINS_GAME_VIEW_SLOTS.OVERLAY_REEL_SET,
  };
}

export default FreeSpinsGameViewController;
